<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="untitled-1">
<div class="calibre1">
<p class="normal"><span class="no-style-override12"><br class="calibre1"/></span></p>
</div>
<div class="calibre1">
<p class="normal"><br class="calibre1"/></p>
<p class="chapter-sub">Acknowledgments:</p>
<p class="firstparagraph"><span class="no-style-override8">Special gratitude is extended to Jennifer Guyor Jowett and Lori Kronser, editors extraordinaire, for their detailed critique of the early manuscript; to Rowena Carenen of WildBlue Press, for her detail-oriented and meticulous eye; to Christian Maheux, for his cover design; Linda Lou, for finding the cruise of the century; Stu and Donna, for pulling the Mediterranean trip together so nicely; and to a variety of friends and relatives – from Bill Kohlmeyer and Doc Strand and Michael J. Parker to my cousins Vinny and Bob to – hey, you know who you are – who once again served up their names and expertise to the cause. Simply put, I couldn’t get there without you. Nor would I want to.   </span><span class="no-style-override7"><br class="calibre1"/></span></p>
<p class="calibre3" id="calibre_pb_8"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?0feae0d6